const DataCollectConstants = {
    status: {
        ALL: 'all',
        APPROVED: 'approved',
        PENDING: 'pending',
        REJECTED: 'rejected',
    },
    device: {
        ALL: 'all',
        ANDROID: 'android',
        IOS: 'ios',
        WINDOWS: 'windows',
        MAC: 'mac',
        OTHER: 'other',
    },
};

export default DataCollectConstants;
